import {
  axios,
  URL_BASE,
  URL_EMPLOYEE,
  URL_EMPLOYEE_HEIGHT,
  URL_EMPLOYEE_IMPORT,
  URL_EMPLOYEE_IMPORT_VALIDATE,
  URL_EMPLOYEE_IMPORT_CONFIRM,
  URL_EMPLOYEE_IMPORT_STATUS,
  URL_PICTURE,
  URL_REGISTER,
  URL_USER,
  URL_REGISTRY_IMPORT,
  URL_FOLDER,
  URL_DOCUMENTACION,
} from "./_shared";

// =============================================
// ── Empleados ──
// =============================================

// ── Registro / UUID ──

export const getRegister = () => {
  return axios.get(URL_REGISTER, {
    params: {
      page: 0,
      size: 500,
    },
  });
};

export const getRegisterMonth = (month, year) => {
  return axios.get(`${URL_REGISTER}/monthly/${month}/${year}`);
};

export const getRegisterEmployee = (EId, month) => {
  return axios.get(`${URL_REGISTER}/user/${EId}/monthly/${month}`, {
    params: {
      page: 0,
      size: 100,
    },
  });
};

export const getUUID = (email) => {
  return axios.get(URL_EMPLOYEE + "/search/" + email);
};

export const getDateUser = (username) => {
  return axios.get(URL_USER + username, {
    withCredentials: true,
  });
};

// ── Importación ──

export const getImportEmployees = async (file, { company } = {}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (company) {
      formData.append("company", company); // opcional
    }

    const response = await axios.post(URL_EMPLOYEE_IMPORT, formData);
    console.log("Respuesta del servidor:", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Código de estado:", error.response.status);
      console.error("Datos de la respuesta:", error.response.data);
      throw error.response.data;
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request);
      throw new Error("No se recibió respuesta del servidor.");
    } else {
      console.error("Error al configurar la solicitud:", error.message);
      throw new Error(error.message);
    }
  }
};

// ==================== IMPORTACIÓN V2 (2 PASOS) ====================

export const validateImportEmployees = async (file, { company } = {}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (company) {
      formData.append("company", company);
    }
    const response = await axios.post(URL_EMPLOYEE_IMPORT_VALIDATE, formData);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw new Error(error.message || "Error al validar el archivo.");
  }
};

export const confirmImportEmployees = async (validationId) => {
  try {
    const response = await axios.post(`${URL_EMPLOYEE_IMPORT_CONFIRM}/${validationId}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw new Error(error.message || "Error al iniciar la importación.");
  }
};

export const getImportTaskStatus = async (taskId) => {
  const response = await axios.get(`${URL_EMPLOYEE_IMPORT_STATUS}/${taskId}`);
  return response.data;
};

export const pollImportTask = async (taskId, onProgress, interval = 2000, maxRetries = 5, timeoutMs = 180000) => {
  return new Promise((resolve, reject) => {
    let cancelled = false;
    let retries = 0;
    const startTime = Date.now();

    const checkStatus = async () => {
      if (cancelled) return;
      if (Date.now() - startTime > timeoutMs) {
        reject(new Error("Tiempo de espera agotado. La importacion puede haberse completado, verifique la lista de empleados."));
        return;
      }
      try {
        const resultado = await getImportTaskStatus(taskId);
        retries = 0;
        if (onProgress) onProgress(resultado);

        if (resultado.estado === "COMPLETADO" || resultado.estado === "ERROR") {
          resolve(resultado);
          return;
        }
        setTimeout(checkStatus, interval);
      } catch (error) {
        const status = error.response?.status;
        if ((status === 404 || !error.response) && retries < maxRetries) {
          retries++;
          setTimeout(checkStatus, interval);
        } else {
          reject(error);
        }
      }
    };

    checkStatus();

    return { cancel: () => { cancelled = true; } };
  });
};

// ==================== FIN IMPORTACIÓN V2 ====================

export const getImportAsistent = (file) => {
  const axiosInstance = axios.create();
  const formData = new FormData();
  formData.append("file", file);
  const token = sessionStorage.getItem("access_token");
  return axiosInstance.post(URL_REGISTRY_IMPORT, formData, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
    .then(response => {
      console.log("Respuesta del servidor:", response.data);
    })
    .catch(error => {
      if (error.response) {
        console.error("Código de estado:", error.response.status);
        console.error("Datos de la respuesta:", error.response.data);
      } else if (error.request) {
        console.error("No se recibió respuesta del servidor:", error.request);
      } else {
        console.error("Error al configurar la solicitud:", error.message);
      }
    });
};

// ── Persona / Empleados CRUD ──

export const getListPersona = (id) => {
  return axios.get(URL_EMPLOYEE + "/" + id + "/profile", {
    params: {
      id: id,
    },
  });
};

export const getPersonaId = (id) => {
  return axios.get(URL_EMPLOYEE + "/" + id);
};

export const getDocumentacion = (id) => {
  return axios.get(URL_DOCUMENTACION + '/' + id);
};

export const getPersona = (currentPage = 0, employeesPerPage = 2000) => {
  return axios.get(URL_EMPLOYEE, {
    params: {
      page: currentPage,
      size: employeesPerPage,
    },
  });
};

export const getEmpleados = (
  currentPage = 0,
  employeesPerPage = 2000,
  { signal, q, role, userId } = {}
) => {
  const params = {
    page: currentPage,
    size: employeesPerPage,
    role,
    userId,
  };

  if (q && String(q).trim().length > 0) {
    params.q = String(q).trim();
  }

  return axios.get(URL_EMPLOYEE, {
    params,
    signal,
  });
};

// El legajo que recibe el próximo alta si no se escribe uno (el último + 1), para mostrarlo en el modal.
export const getProximoLegajo = () => axios.get(`${URL_EMPLOYEE}/next-employee-number`);

export const getEmpleadosSimpleDTO = (
  currentPage = 0,
  employeesPerPage = 2000,
  { signal, q, withRoles, allCompany, context } = {}
) => {
  const params = {
    page: currentPage,
    size: employeesPerPage,
  };

  if (q && String(q).trim().length > 0) {
    params.q = String(q).trim();
  }

  if (withRoles) {
    params.withRoles = true;
  }

  if (allCompany) {
    params.allCompany = true;
  }

  if (context) {
    params.context = context;
  }

  return axios.get(URL_EMPLOYEE + '/pick', {
    params,
    signal,
  });
};

export const postPicture = (formData, company, id) => {
  return axios(URL_PICTURE + 'uploadProfile', formData, {
    params: {
      company: company,
      uuid: id
    },
    method: 'POST'
  });
};

export const postUser = (formDataUser) => {
  return axios(URL_USER + "register", {
    data: JSON.stringify(formDataUser),
    method: 'POST'
  });
};

export const postEmpleado = (dto) => {
  return axios(URL_EMPLOYEE, {
    data: JSON.stringify(dto),
    method: 'POST'
  });
};

/**
 * Baja del empleado. leavingDate (AAAA-MM-DD, opcional) viaja como leaving_date:
 * el backend la valida (<= hoy y >= la fecha de ingreso, 400 si no). Sin ella el
 * backend usa hoy, como antes: así siguen andando las pantallas que todavía no
 * la mandan.
 */
export const deleteEmployee = (id, comments, leavingDate) => {
  const data = {};
  if (comments) data.comments = comments;
  if (leavingDate) data.leaving_date = leavingDate;
  return axios.delete(URL_EMPLOYEE + '/' + id, {
    data: Object.keys(data).length > 0 ? data : undefined
  });
};

export const postAlta = async (dto) => {
  const res = await fetch(URL_EMPLOYEE_HEIGHT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dto),
  });

  let data = {};
  try {
    data = await res.json();
  } catch (_) {
  }

  if (!res.ok) {
    throw { status: res.status, ...data };
  }
  return data;
};

// ── Perfil ──

export const getMiPerfil = (idUser) => {
  return axios.get(URL_EMPLOYEE + '/' + idUser + '/profile', {
    params: {
      id: idUser
    }
  });
};

export const putMiPerfil = (id, data, company) => {
  return axios(`${URL_EMPLOYEE}/${id}/profile?company=${company}`, {
    data: data,
    method: 'put'
  });
};

export const putMiPerfilEmpleado = (id, data) => {
  return axios(URL_EMPLOYEE + '/' + id + '/profile', {
    data: data,
    method: 'put'
  });
};

export const putPerfil = (id, data, company) => {
  return axios.put(`${URL_EMPLOYEE}/${id}?company=${company}`, data);
};

export const putUsuario = (id, data) => {
  return axios(URL_USER + id, {
    data: data,
    method: 'put'
  });
};

// ── Exportar empleado PDF ──

export const getExportEmployee = (uuid, name, lastName) => {
  if (!uuid) {
    throw new Error('UUID is required to export employee PDF');
  }

  if (!name || !lastName) {
    throw new Error('Name and Last Name are required to generate the file name');
  }

  const url = `${URL_EMPLOYEE}/${uuid}/export-pdf`;

  return axios.get(url, {
    responseType: 'arraybuffer'
  })
    .then(response => {
      const formattedName = `${name}${lastName}`.replace(/\s+/g, '');
      const filename = `${formattedName}.pdf`;

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
    })
    .catch(error => {
      console.error('Error exporting employee PDF:', error);
      throw error;
    });
};

// ── Pendientes / Nuevos ingresos ──

export const getPendingSummary = (employeeUuid) => {
  return axios.get(`${URL_BASE}pending/summary/${employeeUuid}`);
};

export const getPendingMe = () => {
  return axios.get(`${URL_BASE}pending/me`);
};

export const getEmpleandosPendientes = async () => {
  const response = await axios.get(`${URL_BASE}admin/registro/pendientes`);
  return response.data.data;
};

export const getNuevosIngresos = async (page = 0, size = 20, { fechaDesde, fechaHasta } = {}) => {
  const params = { page, size };
  if (fechaDesde) params.fechaDesde = fechaDesde;
  if (fechaHasta) params.fechaHasta = fechaHasta;
  const response = await axios.get(`${URL_EMPLOYEE}/nuevos-ingresos`, { params });
  return response.data;
};

export const postAprobarPendientes = async (id, payload = {}) => {
  const response = await axios.post(
    `${URL_BASE}admin/registro/aprobar/${id}`,
    payload
  );
  return response.data;
};

export const postAprobarPendientesMasivo = async (ids, options = {}) => {
  const payload = {
    ids,
    roles: options.roles || ["ROLE_USER"],
    employeeNumberPrefix: options.employeeNumberPrefix || null,
  };
  const response = await axios.post(`${URL_BASE}admin/registro/aprobar-masivo`, payload);
  return response.data;
};

export const getEstadoTareaAprobacion = async (taskId) => {
  const response = await axios.get(`${URL_BASE}admin/registro/tarea/${taskId}`);
  return response.data;
};

export const deleteEmpleadosPendientesMasivo = async (ids) => {
  const response = await axios.delete(`${URL_BASE}admin/registro/eliminar-masivo`, {
    data: ids,
  });
  return response.data;
};

export const pollTareaAprobacion = async (taskId, onProgress, interval = 2000) => {
  return new Promise((resolve, reject) => {
    const checkStatus = async () => {
      try {
        const response = await getEstadoTareaAprobacion(taskId);
        const resultado = response.data;

        if (onProgress) {
          onProgress(resultado);
        }

        if (resultado.estado === "COMPLETADO" || resultado.estado === "ERROR") {
          resolve(resultado);
          return;
        }

        setTimeout(checkStatus, interval);
      } catch (error) {
        reject(error);
      }
    };
    checkStatus();
  });
};

export const deleteEmpleadoPendiente = async (id) => {
  const response = await axios.delete(`${URL_BASE}admin/registro/eliminar/${id}`);
  return response.data;
};

// ── Imagen de perfil ──

export const getImagenPerfil = (uuid, photoKey) => {
  const params = photoKey ? { key: photoKey } : { uuid };
  return axios.get(`${URL_FOLDER}/perfil`, {
    params,
    responseType: 'blob'
  });
};

export const putImagenPerfil = (uuid, file) => {
  const formData = new FormData();
  formData.append("uuid", uuid);
  formData.append("file", file);
  return axios.put(`${URL_FOLDER}/perfil`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

// ── Roles / Listados especiales ──

export const getListEmployeeRoleAdminAndRRHH = (company) => {
  return axios.get(URL_EMPLOYEE, {
    params: {
      company: company,
    },
  });
};

export const getJefesArea = () => {
  return axios.get(`${URL_EMPLOYEE}/jefes-area`);
};

export const getSupervisores = (company) => {
  return axios.get(`${URL_EMPLOYEE}/supervisores`, {
    params: { company }
  });
};

export const getEmpleadosTecnicos = (company) => {
  return axios.get(`${URL_EMPLOYEE}/tecnicos`, {
    params: { company }
  });
};

// ── Empleados por área ──

export const getEmployeesByArea = (areaId) =>
  axios.get(`${URL_EMPLOYEE}/area/${areaId}`);

// ── Stub ──

export const getEmpleadoBasico = async () => {
  return {
    data: ["VACACIONES", "ENFERMEDAD", "FERIADO", "PERMISO", "INJUSTIFICADA", "SUSPENSION"]
  };
};

// ── Inactivos ──

export const getEmpleadosInactivos = async (page = 0, size = 20, q = "") => {
  const params = new URLSearchParams({ page, size });
  if (q) params.append("q", q);
  return await axios.get(`${URL_BASE}employee/inactive?${params.toString()}`);
};

export const reactivateEmployee = async (id) => {
  return await axios.put(`${URL_BASE}employee/${id}/reactivate`);
};

// ── Exportar nómina ──

export const exportarNominaEmpleados = (format, areaId) => {
  const params = { format };
  if (areaId) params.areaId = areaId;
  return axios.get(`${URL_BASE}employee/export-nomina`, {
    params,
    responseType: 'blob'
  });
};

// ── Exportar nómina configurable (columnas, áreas, estado) ──
// Contrato en snake_case; el cuerpo lo arma armarBody/armarFiltros de forms/Empleado/exportNominaUtils.

/** Grupos, columnas y áreas que el usuario puede exportar, más los límites. Devuelve el DTO directo. */
export const getCatalogoExportNomina = () => {
  return axios.get(`${URL_BASE}employee/export/catalogo`);
};

/** { total, activos, bajas } para esos filtros. `signal` es de un AbortController (el conteo se cancela al tipear). */
export const contarExportNomina = (body, signal) => {
  return axios.post(`${URL_BASE}employee/export/conteo`, body, { signal });
};

/** El .xlsx. Los errores también llegan como Blob: leerlos con mensajeDeErrorBlob. */
export const exportarNominaPersonalizada = (body) => {
  return axios.post(`${URL_BASE}employee/export`, body, { responseType: 'blob' });
};
